import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { APP_PATHS } from '../../constants';
import { Capacitor } from '@capacitor/core';
import { attachFirebaseInstanceId } from 'api/user';

// Send event of screen_view every time the route changes (it uses useEffect hook, and currently being used as a comppent in router, which being acitivated per all routes)
const FirebaseScreenViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Only run on native platforms where Firebase Analytics is available
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    const getScreenName = (pathname: string): string => {
      switch (pathname) {
        case APP_PATHS.BASE:
          return 'Home';
        case APP_PATHS.LOGIN:
          return 'Login';
        case APP_PATHS.SIGN_UP:
          return 'SignUp';
        case APP_PATHS.OFFERS:
          return 'Games';
        case APP_PATHS.SURVEYS:
          return 'Surveys';
        case APP_PATHS.PROFILE:
          return 'Profile';
        case APP_PATHS.CASHOUT:
          return 'Cashout';
        case APP_PATHS.ABOUT_US:
          return 'AboutUs';
        case APP_PATHS.PRIVACY:
          return 'Privacy';
        case APP_PATHS.TERMS:
          return 'Terms';
        case APP_PATHS.CONTACT_US:
          return 'ContactUs';
        case APP_PATHS.EMAIL_CONFIRMATION:
          return 'EmailConfirmation';
        case APP_PATHS.RESET_PASSWORD:
          return 'ResetPassword';
        case APP_PATHS.VERIFY_EMAIL:
          return 'VerifyEmail';
        case APP_PATHS.ERROR:
          return 'NotFound';
        default:
          if (pathname.startsWith(APP_PATHS.OFFER)) {
            return 'Offer';
          }
          return 'Unknown';
      }
    };
    
    // Get the screen name based on the current path
    const screenName = getScreenName(location.pathname);
    // Log screen view event (the screen name will be attached automatically)
    void FirebaseAnalytics.logEvent({
      name: 'screen_view',
      params: {
        screen_name: screenName
      }
    }); 

  }, [location.pathname]);

  return null;
};

// Get app instance ID and update in backend
// This is used to match the analytics data with user
// Currently beind used each signup or sign in, to keep the instance ID updated (it changes very rarely, but in this way make it sure it is always up to date)
const HandleAppInstance = () => {

  if (!Capacitor.isNativePlatform()) return;
  
  // Get Firebase App Instance ID and update in backend
  FirebaseAnalytics.getAppInstanceId()
    .then((result) => {
      const instanceId = result?.appInstanceId;
      if (instanceId && typeof instanceId === 'string' && instanceId.length > 0) {
        // Send request to backend to update the instance ID, try several times (optimistic approach - assume it will succeed)
        void attachFirebaseInstanceId(instanceId)
      }
      else {
        // Instance ID is not available
      }
    })
    .catch((error) => {
      // Unable to get instance ID
    });

};


export { FirebaseScreenViewTracker, HandleAppInstance };